import React from 'react'
import { Link, withPrefix } from 'gatsby'

const BaseCandidatoCard = ({ className, url, children, partido }) => {
  // divisas de sorteo: 328px x 123px
  // const data = useStaticQuery(graphql`
  //   query divisas {
  //     allFile(filter: { sourceInstanceName: { eq: "divisas" } }) {
  //       edges {
  //         node {
  //           childImageSharp {
  //             gatsbyImageData(
  //               width: 59
  //               height: 22
  //               formats: [JPG]
  //               transformOptions: { fit: FILL }
  //             )
  //           }
  //           name
  //         }
  //       }
  //     }
  //   }
  // `)

  // const image = getImage(
  //   data.allFile.edges.find(edge => edge.node.name == partido.idPartido.toString()).node
  //     .childImageSharp
  // )

  return (
    <Link to={url}>
      <div
        className={`w-40 h-40 p-6 rounded-lg border border-solid border-gray-200 ${className}`}
        style={{
          boxShadow: '0 10px 28px rgba(0,0,0,.08)',
        }}
      >
        <div className="-mt-20 mb-12 text-xs font-semibold">{partido.siglasPartido}</div>
        <div className="-mt-12 mx-auto mb-8">
          {/* <GatsbyImage image={image} alt="" /> */}
          <img
            className="mx-auto"
            src={`${withPrefix('/images/divisas/')}${partido.idPartido.toString()}.jpg`}
            alt=""
            width="59"
            height="22"
          />
        </div>

        {children}
      </div>
    </Link>
  )
}

export default BaseCandidatoCard
